<div *ngIf="loadingSpinner" class="spinner-container">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" animationDuration=".5s"></p-progressSpinner>
</div>
<p-dialog [(visible)]="displayWarehouseView" [modal]="true" [responsive]="true" [closable]="false" [style]="{width: '60vw'}"
>
  <ng-template pTemplate="header">
      <h5 style="width: 100%;">Location View Page
      <span style="float: right;cursor: pointer;"
          class="pi pi-pencil" (click)="edit(savedLocation)"></span>
      </h5>
  </ng-template>
 <form [formGroup]="locationForm">
  <div class="header">
    <h5>Location Information
      <p-inputSwitch class="header-switch" formControlName="statusId"></p-inputSwitch>
    </h5>
  </div>
  <div class="card">
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-6">
        <label for="name">Location ID<span style="color: red;">*</span></label>
        <input type="text"  pInputText formControlName="locationId">
      </div>
      <div class="p-col-6">
        <label for="name">Name<span style="color: red;">*</span></label>
        <input type="text" pInputText formControlName="name">
      </div>
    </div>
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-4">
        <label>Type</label>
        <p-dropdown appendTo="body" [options]="types" optionLabel="name" 
           formControlName="typeId" ></p-dropdown>
      </div>
      <div class="p-col-4">
        <label>Group</label>
        <p-dropdown appendTo="body" [options]="groups" optionLabel="name" 
          formControlName="groupId"></p-dropdown>
      </div>
      <div class="p-col-4">
        <label>Category</label>
        <p-multiSelect appendTo="body" [options]="category" optionLabel="name" 
         formControlName="warehouseCategory" placeholder="Select Category">
        </p-multiSelect>
      </div>
    </div>
  </div>
  <div class="header">
    <h5>Address Information</h5>
  </div>
  <div class="card">
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12 p-lg-6">
        <label>Street Address 1</label>
        <input pInputText type="text"  [ngModelOptions]="{ standalone: true }" [(ngModel)]="formattedAddress" disabled/>
      </div>
      <div class="p-col-12 p-lg-6">
        <label>Street Address 2</label>
        <input pInputText type="text" [(ngModel)]="streetAddress2" disabled [ngModelOptions]="{ standalone: true }">
      </div>
    </div>
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12 p-lg-6">
        <label>Country</label>
        <p-dropdown appendTo="body" [disabled]="true" [ngModelOptions]="{ standalone: true }" [options]="country" optionLabel="name" [(ngModel)]="selectedCountry" placeholder="Select Country" [filter]="true"  (onChange)="getStatesFromCountry($event.value)">
        </p-dropdown>
      </div>
      <div class="p-col-12 p-lg-6">
        <label>State</label>
        <p-dropdown appendTo="body"  [disabled]="true"  [ngModelOptions]="{ standalone: true }" [options]="states" placeholder="Select State" [(ngModel)]="selectedState" [filter]="true"  optionLabel="name"  (onChange)="getCitiesFromState($event.value)">
        </p-dropdown>
      </div>
    </div>
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12 p-lg-6">
        <label>City</label>
        <p-dropdown appendTo="body"  [disabled]="true"  [ngModelOptions]="{ standalone: true }" [options]="city" placeholder="Select City" [(ngModel)]="selectedCity" [filter]="true" optionLabel="name" ></p-dropdown>
      </div>
      <div class="p-col-12 p-lg-3">
        <label>Zipcode</label>
        <input pInputText type="text"  [disabled]="true"  [ngModelOptions]="{ standalone: true }" [(ngModel)]="zipCode">
      </div>
      <div class="p-col-12 p-lg-3">
        <label>Contact Person</label>
        <p-autoComplete formControlName="userId" [suggestions]="allContactsDD"  [disabled]="true"
          (completeMethod)="filterContact($event)" field="fullName" [minLength]="1"
          placeholder="Search contact" (onClear)="clearContact($event)">
        </p-autoComplete>
      </div>
    </div>
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12 p-md-6">
        <label>Location Email<span style="color: red;">*</span></label>
        <input pInputText type="text" formControlName="emailId">
      </div>
      <div class="p-col-12 p-md-6">
        <label>Location Phone<span style="color: red;">*</span></label>
        <input pInputText type="text" formControlName="phoneNo">
      </div>
    </div>
  </div>
 </form>
<p-footer>
<button type="button" pButton (click)="closeViewDialog()" label="Cancel" class="p-button-secondary"></button>
</p-footer>
</p-dialog>



<p-dialog header="{{header}}" [(visible)]="display" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}" (onHide)="setDialogProperty(false)">

    <app-subscription-limit-message
        *ngIf="subscriptionLimitReached"
        [subscriptionLimit]="subscriptionLimit"
        [moduleName]="'Location'">
    </app-subscription-limit-message>

  <form *ngIf="!subscriptionLimitReached" [formGroup]="locationForm">
    <div class="header">
      <h5>Location Information
        <p-inputSwitch class="header-switch" formControlName="statusId" [disabled]="statusDisabled" (onChange)="checkWarehouseStatus()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-6">
          <label for="name">Location ID<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="locationId" (focusout)="checkDuplicateLocationId()">
          <small *ngIf="duplicateItem" class="p-invalid">
            LocationID already exists.
          </small>
        </div>
        <div class="p-col-6">
          <label for="name">Name<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="name">
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-4">
          <label>Type</label>
          <p-dropdown appendTo="body" [options]="types" optionLabel="name"
             formControlName="typeId" [filter]="true"></p-dropdown>
        </div>
        <div class="p-col-4">
          <label>Group</label>
          <p-dropdown appendTo="body" [options]="groups" optionLabel="name"
            formControlName="groupId" [filter]="true" (onChange)="addNewOption(locationForm.value)"></p-dropdown>
        </div>
        <div class="p-col-4">
          <label>Category</label>
          <p-multiSelect appendTo="body" [options]="category" optionLabel="name"
           formControlName="warehouseCategory" placeholder="Select Category">
          </p-multiSelect>
        </div>
      </div>
    </div>
    <div class="header">
      <h5>Address Information</h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
          <label>Street Address 1</label>
          <lion-gm-place-autocomplete
          [formattedAddress]="addressInput"
          (onRemoveAddress)="removeAddressLocation()"
          (onAddressChange)="locationAddresChanged($event)"
          (onSettingAddrress)="onAddressBlur($event)">
        </lion-gm-place-autocomplete>
        <small class="p-invalid">{{ ErrorMessageSetLocation }}</small>
        </div>
        <div class="p-col-12 p-lg-6">
          <label>Street Address 2</label>
          <input pInputText type="text" [(ngModel)]="streetAddress2" [ngModelOptions]="{ standalone: true }">
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
          <label>Country</label>
          <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="country" optionLabel="name" [(ngModel)]="selectedCountry" placeholder="Select Country" [filter]="true"  (onChange)="getStatesFromCountry($event.value)">
          </p-dropdown>
        </div>
        <div class="p-col-12 p-lg-6">
          <label>State</label>
          <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="states" placeholder="Select State" [(ngModel)]="selectedState" [filter]="true"  optionLabel="name"  (onChange)="getCitiesFromState($event.value)">
          </p-dropdown>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
          <label>City</label>
          <p-dropdown appendTo="body" [ngModelOptions]="{ standalone: true }" [options]="city" placeholder="Select City" [(ngModel)]="selectedCity" [filter]="true" optionLabel="name" ></p-dropdown>
        </div>
        <div class="p-col-12 p-lg-3">
          <label>Zipcode</label>
          <input pInputText type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="zipCode">
        </div>
        <div class="p-col-12 p-lg-3">
          <label>Contact Person</label>
          <p-autoComplete formControlName="userId" [suggestions]="allContactsDD"
            (completeMethod)="filterContact($event)" field="fullName" [minLength]="1"
            placeholder="Search contact" (onClear)="clearContact($event)">
          </p-autoComplete>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <label>Location Email<span style="color: red;">*</span></label>
          <input pInputText type="text" formControlName="emailId">
        </div>
        <div class="p-col-12 p-md-6">
          <label>Location Phone<span style="color: red;">*</span></label>
          <input pInputText type="text" formControlName="phoneNo">
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="display=false" label="Cancel"
      class="p-button-secondary"></button>
    <button *ngIf="!subscriptionLimitReached" type="button" pButton label="Save" [disabled]="!locationForm.valid || duplicateItem || isDisabled"  (click)="saveLocation(locationForm.value)"></button>
  </p-footer>
</p-dialog>


<p-dialog header="{{addEditOptionHeader}}" [modal]="true" [(visible)]="displayAddNewOption" [style]="{width: '50vw'}"
  [baseZIndex]="10000" (onHide)="addNewOptionForm.reset()">
  <form [formGroup]="addNewOptionForm">
    <div class="p-grid">
      <div class="p-col-6">
        <label for="name">Group Name <span style="color: red;">*</span></label>
        <input type="text" pInputText formControlName="name">
        <small *ngIf="invalidGroupData" class="p-invalid">Name already exists.</small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton (click)="displayAddNewOption=false" label="Cancel" class="p-button-secondary"></button>
    <button pButton [disabled]="!addNewOptionForm.valid" (click)="saveGroup(addNewOptionForm.value)"
      label="Save"></button>
  </ng-template>
</p-dialog>